"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var hasEntity = function hasEntity(_ref) {
  var block = _ref.block,
      entityKey = _ref.entityKey;
  var hasEntityKey = false;
  block.findEntityRanges(function (char) {
    var blockEntityKey = char.getEntity();
    return blockEntityKey !== null && "" + blockEntityKey === entityKey;
  }, function () {
    hasEntityKey = true;
  });
  return hasEntityKey;
};

function _default(_ref2) {
  var contentState = _ref2.contentState,
      entityKey = _ref2.entityKey;
  var blocks = contentState.getBlockMap();
  return blocks.findLast(function (block) {
    return hasEntity({
      block: block,
      entityKey: entityKey
    });
  });
}

module.exports = exports.default;